import MarketSnapshotsBaseController from 'lumen/controllers/market/snapshots/base';
import type MarketSnapshotsForecastRoute from 'lumen/routes/market/snapshots/forecast';
import { SNAPSHOT_VIEW_CONFIG } from 'lumen/utils/constants/market-snapshots-constants';
import type { ModelFrom } from 'lumen/utils/routes';

export default class MarketSnapshotsForecastController extends MarketSnapshotsBaseController {
  declare model: ModelFrom<MarketSnapshotsForecastRoute>;

  readonly config = SNAPSHOT_VIEW_CONFIG.forecast;
}
